import {Setting} from "./Setting";

export const socialSetting: Setting = {
    key: "Social",
    title: "Социум",
    description: `Социум охватывает все аспекты общества, социальные взаимодействия, поведение людей и другие элементы, которые определяют, как персонажи взаимодействуют друг с другом в рамках определённого мира. Социум — это не просто население или демографические данные, но и культурные, социальные и психологические аспекты, влияющие на развитие сюжета и жизнь персонажей.`,
    components: [
        {
            title: "Социальные слои и классы",
            subComponents: [
                {
                    title: "Элита и аристократия",
                    description: `Дворяне, магнаты, богатые торговцы, маги или высокопоставленные представители власти, которые контролируют ресурсы и принимают важные решения.`,
                    examples: ["Королевский двор, где собираются влиятельные особы и аристократы."]
                },
                {
                    title: "Средний класс",
                    description: `Умеренно обеспеченные жители, такие как ремесленники, купцы, ученые, врачи и представители профессиональных сфер.`,
                    examples: ["Гильдия мастеров, объединяющая ремесленников и артистов."]
                },
                {
                    title: "Рабочий класс",
                    description: `Люди, работающие на фабриках, в сельском хозяйстве, в службе у богатых или в других сферах, требующих физического труда.`,
                    examples: ["Шахтеры, работающие в глубоких шахтах."]
                },
                {
                    title: "Бедняки и нищие",
                    description: `Люди, живущие в условиях нищеты или без определённого жилья, часто с ограниченными возможностями для улучшения своего положения.`,
                    examples: ["Бомжи, живущие на улицах города."]
                },
                {
                    title: "Угнетённые и маргинализированные группы",
                    description: `Небольшие группы или меньшинства, подвергающиеся угнетению из-за расовой, этнической, социальной, экономической или религиозной принадлежности.`,
                    examples: ["Эльфы, живущие в изоляции от человеческого общества."]
                }]
        },
        {
            title: "Социальные институты",
            subComponents: [
                {
                    title: "Семья",
                    description: `Основной институт, на котором базируется большинство обществ, регулирующий личные отношения, наследование и воспитание потомства.`,
                    examples: ["Дворянская семья, где важно сохранить родовое достояние."]
                },
                {
                    title: "Образование",
                    description: `Школы, университеты, школы магии или другие образовательные учреждения, которые влияют на развитие персонажей и общество в целом.`,
                    examples: ["Магическая академия, где обучаются будущие колдуны и чародеи."]
                },
                {
                    title: "Медицина",
                    description: `Лечебные учреждения и специалисты, которые занимаются здоровьем и лечением населения, включая магов-целителей в фэнтезийных мирах.`,
                    examples: ["Целительница, использующая травы и заклинания для лечения болезней."]
                },
                {
                    title: "Церковь или религиозные организации",
                    description: `Роль религии в обществе, влияния храмов, священников и религиозных лидеров на политику и общественные ценности.`,
                    examples: ["Храм, где собираются верующие для молитв и обрядов."]
                }]
        },
        {
            title: "Традиции и обычаи",
            subComponents: [
                {
                    title: "Праздники и фестивали",
                    description: `Специфические культурные события, которые играют важную роль в жизни общества, такие как коронации, свадьбы, народные гуляния или магические праздники.`,
                    examples: ["Фестиваль урожая, празднование богини плодородия."]
                },
                {
                    title: "Ритуалы и обряды",
                    description: `Социально значимые действия, связанные с жизненными событиями (например, инициации, бракосочетания, погребения).`,
                    examples: ["Тайный обряд воскрешения духов предков."]
                },
                {
                    title: "Нормы и табу",
                    description: `Ожидаемое поведение, социальные правила, которые определяют, что является приемлемым, а что — запрещённым в обществе.`,
                    examples: ["Запрет на общение с демонами или нежитью."]
                }]
        },
        {
            title: "Экономические и социальные отношения",
            subComponents: [
                {
                    title: "Труд и профессии",
                    description: `Разнообразие профессий и ролей в обществе: кузнецы, алхимики, дипломаты, маги, охотники, строители и другие.`,
                    examples: ["Торговец, специализирующийся на редких ресурсах."]
                },
                {
                    title: "Долги и обязательства",
                    description: `Обязанности, связанные с контрактами, долгами или социальными обещаниями, влияющие на динамику отношений между персонажами и группами.`,
                    examples: ["Долг перед драконом, который нужно погасить."]
                },
                {
                    title: "Социальные сети",
                    description: `Взаимодействие между персонажами, их связи, группировки и альянсы, через которые распространяются информация, влияние и ресурсы.`,
                    examples: ["Тайное общество, собирающее информацию о власти."]
                }]
        },
        {
            title: "Этническая и культурная принадлежность",
            subComponents: [
                {
                    title: "Раса и этнос",
                    description: `Разнообразие культур и расовых групп, каждый из которых может иметь свои особенности, обычаи, историю и отношение к другим группам.`,
                    examples: ["Эльфы, живущие в лесах и поклоняющиеся природе."]
                },
                {
                    title: "Язык и диалекты",
                    description: `Разнообразие языков и диалектов, которые могут влиять на коммуникацию между персонажами и создавать барьеры или возможности для взаимодействия.`,
                    examples: ["Древний язык драконов, используемый для заклинаний."]
                },
                {
                    title: "Культурные различия",
                    description: `Традиции, искусство, музыка, кухня и другие культурные аспекты, которые создают уникальные черты различных обществ и народов.`,
                    examples: ["Традиция татуировок у воинов племени."]
                }]
        }
    ],
    prompt: {
        component: {
            list: 'Перечисли возможные компоненты социума и опиши их если они применимы к истории. Не ограничивайся основными компонентами если необходимо',
            single: 'Сгенерируй компонент социума для мира. Опиши ключевые аспекты, структуры и последствия социальных взаимодействий.',
            extend: 'Дополни описание компонента социума и разбей на абзацы. Как компонент влияет на мир и персонажей.'
        },
        element: {
            list: 'Перечисли возможные элементы социума и опиши их если они применимы к истории',
            single: 'Сгенерируй элемент социума для мира. Опиши ключевые аспекты, структуры и последствия социальных взаимодействий.',
            extend: 'Дополни описание элемента социума и разбей на абзацы. Как элемент влияет на мир и персонажей.'
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента социума. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента социума. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора социума и разбей на абзацы."
        }
    }
}